import type { DocNode } from '@atlaskit/adf-schema/doc';

type EditorPluginAIEvent = {
	adfResponse?: DocNode | DocNode['content'][number];
	type: 'complete' | 'stream' | 'error';
};

/**
 * Normalises an event into the shape used by actor.send().
 * Required in editor-plugin-ai and editor-plugin-ai-streaming-orchestrator
 * to ensure that the events are in the same shape as the actor.send() events
 * for backwards compatibility.
 *
 * This can be cleaned up with platform_editor_ai_xstate_migration.
 */
export function normaliseAIExperienceEvent(event: EditorPluginAIEvent):
	| {
			adfResponse?: DocNode | DocNode['content'][number];
			cacheKey: string;
			markdown: string;
			// eslint-disable-next-line @typescript-eslint/no-empty-object-type
			modelInput: {};
			type: 'complete' | 'stream' | 'error';
	  }
	| {
			adfResponse?: DocNode | DocNode['content'][number];
			markdown: string;
			type: 'complete' | 'stream' | 'error';
	  }
	| {
			adfResponse?: DocNode | DocNode['content'][number];
			cacheKey: string;
			// eslint-disable-next-line @typescript-eslint/no-empty-object-type
			modelInput: {};
			type: 'complete' | 'stream' | 'error';
	  } {
	switch (event.type) {
		case 'complete':
			return {
				markdown: '',
				cacheKey: '',
				modelInput: {},
				...event,
			};

		case 'stream':
			return {
				markdown: '',
				...event,
			};

		case 'error':
			return {
				cacheKey: '',
				modelInput: {},
				...event,
			};
	}
}
